/* eslint-disable max-classes-per-file */

import { BenefitVerification } from './benefit-verification';

export class FrontCardPicture {
  medium = '/assets/images/placeholder-img.png';
  original = '/assets/images/placeholder-img.png';

  get is_place_holder(): boolean {
    return this.original.includes('placeholder');
  }

  load_from_json(json: any): FrontCardPicture {
    this.medium = json.medium;
    this.original = json.original;

    return this;
  }
}

export class BackCardPicture {
  medium = '/assets/images/placeholder-img.png';
  original = '/assets/images/placeholder-img.png';

  get is_place_holder(): boolean {
    return this.original.includes('placeholder');
  }

  load_from_json(json: any): BackCardPicture {
    this.medium = json.medium;
    this.original = json.original;

    return this;
  }
}

export class PatientInsurance {
  id: number;
  patientId: number;
  groupNumber: string;
  policyNumber: string;
  patientRelationshipTypeId: string;
  dateOfBirth: string;
  deleted: boolean;
  createdAt: string;
  groupPlanName: string;
  eapCompanyName: string;
  phoneNumber: string;
  firstName: string;
  middleName: string;
  lastName: string;
  genderId: number;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  postalCode: string;
  providerNetworkCompanyId: number;
  frontCardName: string;
  frontCardFileContent: string;
  backCardName: string;
  backCardFileContent: string;
  frontCardPictureId: any;
  backCardPictureId: any;
  lastVerifiedDate: string;
  payerName: string;
  payerAddressLine1: string;
  payerAddressLine2: string;
  payerCity: string;
  payerState: string;
  payerZip: string;
  payerPhone: string;
  isEap: boolean;
  hasFrontPdf: boolean;
  hasBackPdf: boolean;
  cardVerificationStatus: string;
  lastVerification: BenefitVerification;
  frontCardPicture: FrontCardPicture;
  backCardPicture: BackCardPicture;
  providersCanAddToClients: boolean;
  usedRedemptions?: number;
  maxRedemptions?: number;
  isUsageBased: boolean;
  ranking: number | null;

  get canRequestCheck(): boolean {
    if (this.deleted || this.isEap) {
      return false;
    }

    return (
      this.lastVerification == null
            || this.lastVerification.aasmState === 'verified'
            || this.lastVerification.aasmState === 'failed'
    );
  }

  get statusName(): string {
    if (this.deleted) {
      return 'Archived';
    }

    if (this.canRequestCheck) {
      return this.lastVerification?.aasmState || 'Active';
    }

    if (this.lastVerification && this.lastVerification.aasmState === 'pending_authorization') {
      return 'Pre-Auth Required';
    }

    if (this.isEap) {
      return 'Active';
    }

    return 'Benefits Check In Progress';
  }

  get canEdit(): boolean {
    return !this.deleted && this.providersCanAddToClients;
  }

  get remainingRedemptions(): number | undefined {
    return !this.isUsageBased ? undefined : this.maxRedemptions - this.usedRedemptions;
  }

  load_from_json(json: any): PatientInsurance {
    this.id = json.id;
    this.patientId = json.patientId;
    this.groupNumber = json.groupNumber;
    this.policyNumber = json.policyNumber;
    this.patientRelationshipTypeId = json.patientRelationshipTypeId;
    this.dateOfBirth = json.dateOfBirth;
    this.deleted = json.deleted;
    this.createdAt = json.createdAt;
    this.groupPlanName = json.groupPlanName;
    this.eapCompanyName = json.eapCompanyName;
    this.phoneNumber = json.phoneNumber;
    this.firstName = json.firstName;
    this.middleName = json.middleName;
    this.lastName = json.lastName;
    this.genderId = json.genderId;
    this.addressLine1 = json.addressLine1;
    this.addressLine2 = json.addressLine2;
    this.city = json.city;
    this.state = json.state;
    this.postalCode = json.postalCode;
    this.providerNetworkCompanyId = json.providerNetworkCompanyId;
    this.ranking = json.ranking;

    if (json.frontCardPicture) {
      this.frontCardPicture = new FrontCardPicture();
      this.frontCardPicture.load_from_json(json.frontCardPicture);
    }

    if (json.backCardPicture) {
      this.backCardPicture = new BackCardPicture();
      this.backCardPicture.load_from_json(json.backCardPicture);
    }

    this.frontCardPictureId = json.frontCardPictureId;
    this.backCardPictureId = json.backCardPictureId;
    this.lastVerifiedDate = json.lastVerifiedDate;

    if (json.lastVerification) {
      this.lastVerification = new BenefitVerification();
      this.lastVerification.load_from_json(json.lastVerification);
    }

    this.isEap = json.isEap;
    this.payerName = json.payerName;
    this.payerAddressLine1 = json.payerAddressLine1;
    this.payerAddressLine2 = json.payerAddressLine2;
    this.payerCity = json.payerCity;
    this.payerState = json.payerState;
    this.payerZip = json.payerZip;
    this.payerPhone = json.payerPhone;
    this.hasFrontPdf = !!(json.frontCardPicture && json.frontCardPicture.original.indexOf('.pdf') > -1);
    this.hasBackPdf = !!(json.backCardPicture && json.backCardPicture.original.indexOf('.pdf') > -1);
    this.usedRedemptions = json.usedRedemptions;
    this.maxRedemptions = json.maxRedemptions;
    this.isUsageBased = json.isUsageBased;

    this.cardVerificationStatus = json.cardVerificationStatus;
    this.providersCanAddToClients = json.providerNetworkCompany.providersCanAddToClients;
    return this;
  }
}
